import { render, staticRenderFns } from "./collect-orders.vue?vue&type=template&id=607fcf7e&scoped=true&"
import script from "./collect-orders.js?vue&type=script&lang=js&"
export * from "./collect-orders.js?vue&type=script&lang=js&"
import style0 from "./collect-orders.scss?vue&type=style&index=0&id=607fcf7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fcf7e",
  null
  
)

export default component.exports